/**
 * Created by shamim.ahsan on 10/24/2018.
 */
import {CommandBase} from "@shared/commands/command-base";
import {TreatyDocumentContent} from "./models/treaty.models";
import {TreatyConfig} from "./orbitax-treaty-config";


// @dynami

export class DownloadTreatyCommad extends CommandBase {
  constructor(public treatyDocument: TreatyDocumentContent) {
    super(TreatyConfig.downloadEventAPI());
    this.projectId = '[PROJECT_ID]';
  }
}

